import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import ProgressBar from './sections/ProgressBar'
import CompanyDetails from './sections/CompanyDetails'
import CompanyMailing from './sections/CompanyMailing'
import CompanySocial from './sections/CompanySocial'
import CompanyDescription from './sections/CompanyDescription'
import CompanyPeople from './sections/CompanyPeople'
import Final from './sections/Final'
import StepLayout from './helpers/StepLayout'
import axios from 'axios'

class Wizard extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      step: 1,
      stepErrors: {},
      welcome_company: {
        files: [],
        name: "",
        your_name: "",
        news_signup: false,
        office_phone: "",
        office_street_address: "",
        office_city: "",
        office_state: "",
        office_country: "",
        office_zip_code: "",
        errors: {},
        description: "",
        people: []
      }
    }

    this.state.welcome_company = this.props.welcome_company
  }

  setData = (data) => {
    const welcomeCompany = {...this.state.welcome_company, ...data}
    Object.keys(data).forEach((key) => welcomeCompany.errors[key] = null)
    this.setState({welcome_company: welcomeCompany})
  }

  setErrors = (step, errors) => {
    const stepErrors = {...this.state.stepErrors}
    stepErrors[step] = {...stepErrors[step], errors}
    this.setState({stepErrors: stepErrors})
  }

  finish = () => {
    this.save((data) => {
      if(Object.keys(data.errors).length == 0) {
        window.location = '/founder-resources'
      }
    }, '/onboarding/form/finalize')
  }

  nextStep = () => {
    this.save((data) => {
      if(Object.keys(data.errors).length == 0) {
        if(this.state.welcome_company.people.length == 0 && this.state.step == 5) {
          if(!confirm("You have not added any people to the leadership team, are you sure you want to go to the next step?")) {
            return
          }
        }
        this.setState({step: this.state.step+1})
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      }
    })
  }

  prevStep = () => {
    this.save(() => this.setState({step: this.state.step-1}))
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  save(callback, baseUrl = '/onboarding/form') {
    const url = this.state.welcome_company.id ? `${baseUrl}/${this.state.welcome_company.id}.json` : baseUrl

    return axios.post(url, {welcome_company: this.state.welcome_company})
      .then((response) => {
        this.setState({welcome_company: response.data.welcome_company})
        callback(response.data.welcome_company)
      })
      .catch((error) => {
        if(error.response && error.response.data && error.response.data.welcome_company) {
          this.setState({welcome_company: error.response.data.welcome_company})
        } else {
          alert("There was an error submitting your information to the server, please try again")
        }
      })
  }

  render() {
    return (
      <div className="form-wizard-container">
        <div className="form-wizard form-wizard--animated">
          <div className="form-wizard__form">
            <StepLayout current={this.state.step} step={1}>
              <div className="col-12 col-md-10 col-lg-8 col-xl-6">
                <CompanyDetails data={this.state.welcome_company} setData={this.setData} />
              </div>
            </StepLayout>

            <StepLayout current={this.state.step} step={2}>
              <div className="col-12 col-md-10 col-lg-8 col-xl-6">
                <CompanyMailing data={this.state.welcome_company} setData={this.setData} />
              </div>
            </StepLayout>
            <StepLayout current={this.state.step} step={3}>
              <div className="col-12 col-md-10 col-lg-8 col-xl-6">
                <CompanySocial data={this.state.welcome_company} setData={this.setData} />
              </div>
            </StepLayout>
            <StepLayout current={this.state.step} step={4}>
              <div className="col-12 col-md-10 col-lg-8 col-xl-6">
                <CompanyDescription data={this.state.welcome_company} setData={this.setData} />
              </div>
            </StepLayout>
            <StepLayout current={this.state.step} step={5}>
              <CompanyPeople data={this.state.welcome_company} setData={this.setData} />
            </StepLayout>
            <StepLayout current={this.state.step} step={6}>
              <div className="col-12 col-md-10 col-lg-8 col-xl-6">
                <Final data={this.state.welcome_company} setData={this.setData} />
              </div>
            </StepLayout>
          </div>
          <ProgressBar
            onNext={() => this.nextStep() }
            onPrev={() => this.prevStep() }
            onFinish={() => this.finish() }
            current={this.state.step}
            total={6}
          />
        </div>
      </div>
    )
  }
}

export default Wizard
